import { render, staticRenderFns } from "./ThirdpartyApp.vue?vue&type=template&id=5300d18a&scoped=true"
import script from "./ThirdpartyApp.vue?vue&type=script&lang=js"
export * from "./ThirdpartyApp.vue?vue&type=script&lang=js"
import style0 from "./ThirdpartyApp.vue?vue&type=style&index=0&id=5300d18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5300d18a",
  null
  
)

export default component.exports